import React from 'react';

const ReadOurBlog: React.FC = () => {
  return (
    <section className="mx-auto px-4 md:px-10 lg:px-32 w-full bg-[#FFFFFF] pt-20 pb-20">
      <div className="">
        <div className="bg-[#F6F6F6] rounded-[30px] p-7 md:p-12 shadow-sm">
          {/* Heading */}
          <h2 className="text-[25px] md:text-[40px] lg:text-[32px] font-[700] leading-[40px] text-[#1A2A44] mb-7 lg:text-left text-[#000000]">
            Junior Mining Blog
          </h2>
          
          {/* Descriptive Text */}
          <p className="text-[16px] md:text-[20px] lg:text-[20px] text-[#000] leading-[29px] font-[400] mb-4 last:mb-0 text-justify">
          Dive into our Junior Mining Blog (#) for in-depth articles on junior mining investment. From analyzing NI 43-101 reports to spotting catalysts like drill results, our blog equips you with mining investment strategies to identify high-potential junior mining stocks. Topics include geological analysis, commodity cycles, and avoiding pitfalls like overhyped promotions. Whether you're a novice or seasoned speculator, our insights—rooted in Rob's proven track record—help you stay ahead of mining speculation trends.
          </p>
          
          {/* Call-to-Action Button */}
          <div className="">
                          <a 
                href="/blog"
                className="inline-block w-full md:w-auto bg-white border-2 border-[#0B6054] px-8 md:px-24 py-3 md:py-3 rounded-[10px] text-[16px] md:text-[18px] font-[600] text-[#0B6054] hover:bg-[#0B6054] hover:text-white transition-all duration-300 transform hover:scale-105 hover:shadow-lg text-center"
                aria-label="Read our blog"
              >
              READ OUR BLOG
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReadOurBlog;
